'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$CompactPlan(code, features) {
  this.DA = null;
  this.KL = null;
  this.DA = code;
  this.KL = features;
}
export { $c_Lpresto_types$CompactPlan as $c_Lpresto_types$CompactPlan };
$p = $c_Lpresto_types$CompactPlan.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$CompactPlan;
/** @constructor */
function $h_Lpresto_types$CompactPlan() {
}
export { $h_Lpresto_types$CompactPlan as $h_Lpresto_types$CompactPlan };
$h_Lpresto_types$CompactPlan.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$CompactPlan)) {
    if ((this.DA === x$0.DA)) {
      var x = this.KL;
      var x$2 = x$0.KL;
      return ((x === null) ? (x$2 === null) : x.i(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "CompactPlan";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.DA;
  }
  if ((n === 1)) {
    return this.KL;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$CompactPlan(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.ju)));
}
export { $isArrayOf_Lpresto_types$CompactPlan as $isArrayOf_Lpresto_types$CompactPlan };
var $d_Lpresto_types$CompactPlan = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$CompactPlan, "presto.types$CompactPlan", ({
  ju: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$CompactPlan as $d_Lpresto_types$CompactPlan };
//# sourceMappingURL=presto.types$-Compact-Plan.js.map
